import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../../ui/dropdown-menu";
import IconProvider from "@/components/ui/IconProvider";

interface AlignmentDropdownProps {
  onFormat: (command: string, value?: string) => void;
}

const alignmentOptions = [
  { value: "justifyLeft", label: "Left", icon: "fa-align-left" },
  { value: "justifyCenter", label: "Center", icon: "fa-align-center" },
  { value: "justifyRight", label: "Right", icon: "fa-align-right" },
];

export const AlignmentDropdown = ({ onFormat }: AlignmentDropdownProps) => {
  const handleAlignmentSelect = (value: string) => {
    onFormat(value);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className="flex flex-row gap-0.5 h-8 px-2 hover:bg-gray-100 text-gray-700 hover:text-gray-900 border-r border-gray-200 "
        >
          <div className="flex flex-col gap-0.5">
            <div className="w-3 h-0.5 bg-current"></div>
            <div className="w-3 h-0.5 bg-current"></div>
            <div className="w-3 h-0.5 bg-current"></div>
          </div>
       
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-48">
        {alignmentOptions.map((option) => (
          <DropdownMenuItem
            key={option.value}
            onClick={() => handleAlignmentSelect(option.value)}
            className="text-sm flex items-center gap-2"
          >
            <IconProvider iconstring={option.icon} size={14} />
            {option.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
